import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-password",
  "use": "icon-password-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-password\"><path d=\"M540.5 26C661.174 26 759 123.826 759 244.5V380h109c38.66 0 70 31.34 70 70v479c0 38.66-31.34 70-70 70H157c-38.66 0-70-31.34-70-70V450c0-38.66 31.34-70 70-70h109V244.5C266 123.826 363.826 26 484.5 26h56zM765 464H261c-46.475 0-84.238 37.298-84.989 83.594L176 549v282c0 46.475 37.298 84.238 83.594 84.989L261 916h504c46.475 0 84.238-37.298 84.989-83.594L850 831V549c0-46.944-38.056-85-85-85zM512.5 578c19.606 0 35.5 15.894 35.5 35.5v150c0 19.606-15.894 35.5-35.5 35.5S477 783.106 477 763.5v-150c0-19.606 15.894-35.5 35.5-35.5z m0-476c-85.021 0-154.106 68.234-155.48 152.929L357 257.5V380h311V257.5c0-85.88-69.62-155.5-155.5-155.5z\" fill=\"#76c6eb\" p-id=\"1510\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/password.svg
// module id = QjmH
// module chunks = 9